<div class="users-toolbar">
  <app-business-partner-selector (businessPartnerChange)="onBusinessPartnerChange($event)"></app-business-partner-selector>
  <div class="search">
    <span class="icon" aria-hidden="true"></span>
    <input type="text"
           [placeholder]="'users.search_placeholder' | translate"
           [value]="searchTerm()"
           (input)="onSearchChange($any($event.target).value)" />
    <button
      class="clear"
      *ngIf="searchTerm()"
      type="button"
      aria-label="Clear search"
      title="Clear search"
      (click)="clearSearch()">
      &times;
    </button>
  </div>
  <label class="checkbox">
    <input type="checkbox" [checked]="showDisabled()" (change)="showDisabled.set($any($event.target).checked)" />
    <span>{{ 'users.show_disabled' | translate }}</span>
  </label>
  <button class="button primary indexed-button" type="button" (click)="openAddDialog()">
    <span class="material-symbols-outlined">add</span>
    {{ 'users.create_user' | translate }}
  </button>
  
</div>

<ng-container *ngIf="loading(); else tableTpl">{{ 'users.loading_users' | translate }}</ng-container>

<ng-template #tableTpl>
  <ng-container *ngIf="!error(); else errTpl">
    <ng-container *ngIf="(users()?.length || 0) === 0; else usersTable">
      <div class="empty">{{ 'users.empty_state' | translate }}</div>
    </ng-container>
    <ng-template #usersTable>
      <table class="users-table">
        <thead>
          <tr>
            <th class="sortable"
                (click)="onSort('Name')"
                [attr.aria-sort]="sortKey()==='Name' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'users.name' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='Name' && sortDir()==='asc'" [class.desc]="sortKey()==='Name' && sortDir()==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('BusinessPartner')"
                [attr.aria-sort]="sortKey()==='BusinessPartner' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'users.business_partner' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='BusinessPartner' && sortDir()==='asc'" [class.desc]="sortKey()==='BusinessPartner' && sortDir()==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('Parent')"
                [attr.aria-sort]="sortKey()==='Parent' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'users.parent' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='Parent' && sortDir()==='asc'" [class.desc]="sortKey()==='Parent' && sortDir()==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('Level')"
                [attr.aria-sort]="sortKey()==='Level' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'users.level' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='Level' && sortDir()==='asc'" [class.desc]="sortKey()==='Level' && sortDir()==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('CopilotEnabled')"
                [attr.aria-sort]="sortKey()==='CopilotEnabled' ? (sortDir()==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'users.copilot_enabled' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey()==='CopilotEnabled' && sortDir()==='asc'" [class.desc]="sortKey()==='CopilotEnabled' && sortDir()==='desc'"></span>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of (filteredUsers() || [])">
            <td>
              <div class="name-cell">
                <img class="avatar" [src]="u.picture" alt="" />
                <div class="meta">
                  <div class="name">{{ u.name }}</div>
                  <div class="email">{{ u.email }}</div>
                </div>
              </div>
            </td>
            <td>{{ u.user_metadata && u.user_metadata.BusinessPartner }}</td>
            <td>{{ u.user_metadata && u.user_metadata.Parent }}</td>
            <td>{{ u.user_metadata && u.user_metadata.Level }}</td>
            <td>
              <label class="switch">
                <input type="checkbox" [checked]="u.user_metadata && u.user_metadata.CopilotEnabled === 1" (change)="toggleCopilot(u)" />
                <span class="slider"></span>
              </label>
            </td>
          </tr>
          <tr class="spacer-row" *ngIf="(users()?.length || 0) > 0">
            <td colspan="5"></td>
          </tr>
        </tbody>
      </table>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #errTpl>
  <div class="error">{{ error() }}</div>
</ng-template>

<app-add-user-dialog *ngIf="showAddDialog()"
  [submitting]="submitting()"
  (closed)="closeAddDialog()"
  (submitUser)="submitNewUser($event)" />
